import BundleProductOptionsOnLoadActionTypes from '../actionTypes/BundleProductOptionsOnLoadActionTypes';

/* Contains the list of SKUs selected for a bundle child item.
Will hold the information only when all the SKUs are selected from a child item */
const BundleProductOptionsOnLoadReducer = function BundleProductOptionsOnLoadReducer(
    state = [],
    action
) {
    switch (action.type) {
        case BundleProductOptionsOnLoadActionTypes.PRODUCTOPTIONSSELECTED_BUNDLE_ONLOAD:
            return action.payload;
        default:
            return state;
    }
};

export default BundleProductOptionsOnLoadReducer;
